import { Controller } from "stimulus"
import selectize from "selectize"

export default class extends Controller {
  static targets = [ "editable", "editableField" ]

  connect() {
    this.editableSelected()
  }

  editableSelected() {
    if ($(this.editableTargets).filter(":checked").val() == "true") {
      $(this.editableFieldTargets).removeAttr("disabled")
    } else {
      $(this.editableFieldTargets).attr("disabled", "disabled")
    }
  }
}
